module.exports = __webpack_public_path__ + "static/media/step6.7e2f2ee2.png";